"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const modal_content_style_1 = __importDefault(require("./modal.content.style"));
class ModalContent extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children, centered } = this.props;
            const rootProps = {
                className: classes.root,
                'data-is-centered': centered
            };
            return (jsx_runtime_1.jsx("div", Object.assign({}, rootProps, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classes.content }, { children: children }), void 0) }), void 0));
        };
    }
}
exports.ModalContent = ModalContent;
ModalContent.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    centered: prop_types_1.default.bool
};
ModalContent.defaultProps = {
    centered: false
};
exports.default = react_jss_1.default(modal_content_style_1.default)(ModalContent);
//# sourceMappingURL=modal.content.js.map